<template>
  <transition name="modal">
    <div class="modal-mask">
      <div
        class="modal-wrapper"
        :class="
          isWider === true ? 'modal-container-wider' : 'modal-container-higher'
        "
      >
        <div class="icons">
          <a download :href="link" target="_self">
            <i class="fas fa-download download-icon"></i>
          </a>
          <i @click="$emit('close')" class="fas fa-times close-icon"></i>
        </div>
        <div class="img-wrapper">
          <img :src="link" alt="slika" />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  created() {
    document.addEventListener('click', this.processClickEvent);
    document.addEventListener('keydown', this.processKeyboardEvent);
  },
  props: {
    link: {
      type: String,
      required: true
    }
  },
  methods: {
    isWider() {
      let img = new Image();
      img.src = this.link;
      let height = img.height;
      let width = img.width;
      return width > height;
    },
    processClickEvent(e) {
      if (
        e.target.tagName === 'A' ||
        e.target.tagName === 'IMG' ||
        e.target.className === 'vsm-list'
      )
        return;
      this.$emit('close');
    },
    processKeyboardEvent(e) {
      if (e.key === 'Escape') {
        this.$emit('close');
      }
    }
  },
  destroyed() {
    document.removeEventListener('click', this.processClickEvent);
    document.removeEventListener('keydown', this.processKeyboardEvent);
  }
};
</script>

<style scoped lang="scss">
.modal-mask {
  position: absolute;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: table;
  transition: opacity 0.3s ease;
}

.img-wrapper {
  width: 100%;
  text-align: center;
  transition: all 0.3s ease;
}

.icons {
  display: flex;
  position: absolute;
  width: auto;
  right: 30px;
  top: 30px;
  i {
    margin: 0 30px 0 0;
  }

  a {
    width: 50px;
  }
}

.download-icon {
  font-size: 25px;
  padding-top: 2px;
  color: white;
  transition: color 0.25s;
}

.download-icon:hover {
  color: var(--primary-color);
}

.close-icon {
  font-size: 30px;
  color: white;
  transition: color 0.25s;
}

.close-icon:hover {
  cursor: pointer;
  color: red;
}

.modal-wrapper {
  display: table-cell;
  width: 100%;
  vertical-align: middle;
}

.btn--mod {
  position: absolute;
  margin: 2% 2% 0 0;
  right: 0;
  top: 0;
}

.modal-footer {
  margin-top: 0;
  button {
    margin: 0 auto;
  }
}

.modal-container {
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-container-wider {
  img {
    max-width: 90vh;
    height: auto;
  }
}

.modal-container-higher {
  img {
    max-height: 90vh;
    width: auto;
  }
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .img-wrapper,
.modal-leave-active .img-wrapper {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
